import styled from '@emotion/styled';
import { defaultContainerSize, mq } from '../../../../styles/mixins';
import { css } from '@emotion/react';

export const Wrapper = styled.div`
  ${defaultContainerSize};

  padding-top: 4rem;
  padding-bottom: 5rem;
  position: relative;
  z-index: 0;
}
`;

export const SocialTitle = styled.h3`
  font-family: ${({ theme }) => theme.font.questrial};
  font-size: 3rem;
  font-weight: 400;
  line-height: 3.5rem;
  letter-spacing: -0.0125rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 2rem 0;
  width: 100%;

  ${mq.large(css`
    font-size: 2.5rem;
    line-height: 3.5rem;
    margin-bottom: 2.5rem;
    letter-spacing: -0.0125rem;
  `)};

  ${mq.xLarge(css`
    font-size: 3rem;
    margin-bottom: 4rem;
  `)}
`;

export const SectionImage = styled.div`
  width: 100%;
  position: relative;
  min-width: 20.5rem;
  min-height: 83rem;
  max-width: 32.5rem;
  max-height: 191rem;
  margin: 0 auto;

  ${mq.medium(css`
    min-width: 42.5rem;
    min-height: 134rem;
    max-width: 40.5rem;
    max-height: 185.875rem;
  `)};

  ${mq.large(css`
    min-width: 57.5rem;
    min-height: 116rem;
    max-width: 40.5rem;
    max-height: 222.625rem;
  `)};

  ${mq.xLarge(css`
    min-width: 73.125rem;
    min-height: 140rem;
    max-width: 73.125rem;
    max-height: 295.75rem;
  `)}
  div {
    position: relative !important;

    img {
      position: relative !important;
      height: 100% !important;
    }
  }

  img {
    object-fit: contain;
  }
`;

export const SectionImageMobile = styled.div`
  width: 100%;
  position: relative;
  min-width: 18rem;
  min-height: 30rem;
  aspect-ratio: 563/721;
  max-width: 32.5rem;
  margin: 0 auto;
`;

export const SocialMediaWrapper = styled.div`
  padding: 2rem 3rem 3rem 3rem;
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.5rem;
`;

export const SocialText = styled.p`
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 400;
  text-align: center;
  color: ${({ theme }) => theme.colors.black};
  margin: 4rem 0 1.5rem 0;

  ${mq.large(css`
    font-size: 2.5rem;
    line-height: 3.5rem;
    margin-top: 2.5rem;
  `)};

  ${mq.xLarge(css`
    margin-top: 0;
  `)}
`;

export const SocialsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f4f4f4;
  gap: 1rem;

  ${mq.medium(css`
    flex-direction: row;
  `)}
`;
